import React, { useState } from "react";
import file from "../img/Fileicon.svg";
import toast, { Toaster } from "react-hot-toast";
import { useEffect } from "react";

const Img2base64 = () => {
  const [value, setvalue] = useState(undefined);

  const handlechange = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader(file);

    if (e.target.files[0].size > 1000000) {
      toast.error("File must should be less than 1 MB");
      setvalue(undefined);
    } else {
      toast.success("Successfully Done");
      reader.readAsDataURL(file);
      reader.onload = (res) => {
        setvalue(res.target.result);
      };
    }
  };

  const handlclick = () => {
    navigator.clipboard.writeText(value);
    toast.success("Copied to clipboard");
  };

  useEffect(()=>{
    document.title="Image to base64 converter"
  })

  return (
    <>
      <div className="container imgcon">
        <h2 className="heading">Image to Base 64 Converter</h2>
        <form>
          <img src={file} alt="" />
          <label htmlFor="input">Drag or Select Image</label>
          <input onChange={handlechange} type="file" name="" id="input" />
        </form>
        <div className="flex cont">
          <div className="previmg">
            <img
              src={value == undefined ? "./placeholder-image.png" : value}
              alt=""
            />
          </div>
          <div className="output">
            <textarea
              value={value == undefined ? null : value}
              placeholder="Your output will be here"
              name=""
              id=""
            ></textarea>
            <div className="btngrp">
              <button
                disabled={value == undefined ? true : false}
                onClick={handlclick}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 4V16C8 16.5304 8.21071 17.0391 8.58579 17.4142C8.96086 17.7893 9.46957 18 10 18H18C18.5304 18 19.0391 17.7893 19.4142 17.4142C19.7893 17.0391 20 16.5304 20 16V7.242C20 6.97556 19.9467 6.71181 19.8433 6.46624C19.7399 6.22068 19.5885 5.99824 19.398 5.812L16.083 2.57C15.7094 2.20466 15.2076 2.00007 14.685 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V4Z"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 18V20C16 20.5304 15.7893 21.0391 15.4142 21.4142C15.0391 21.7893 14.5304 22 14 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V9C4 8.46957 4.21071 7.96086 4.58579 7.58579C4.96086 7.21071 5.46957 7 6 7H8"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="top-center" />
    </>
  );
};

export default Img2base64;
